import ChatDemo, { ChatStep } from './ChatDemo';

/**
 * AI Agent 섹션 데모.
 * 목표를 받으면 계획(Plan) → 도구 호출(Act) → 관찰(Observe) 루프를
 * 트레이스 형태로 스트리밍하며 여러 도구(MCP·RAG·GraphRAG)를 연계한다.
 */
const SCRIPT: ChatStep[] = [
  { kind: 'user', text: '지난 분기 회의 결정사항을 근거와 함께 요약하고, 관련 부서에 공유 초안 만들어줘.' },
  { kind: 'note', label: '계획', text: '회의록 검색 → 관계 그래프로 담당 부서 식별 → 초안 작성' },
  { kind: 'tools', tools: ['search_docs() · RAG', 'query_graph() · GraphRAG', 'send_draft() · MCP'] },
  { kind: 'note', label: '관찰', text: '결정 3건·담당 2개 부서 확인, 근거 출처 매칭 완료' },
  {
    kind: 'bot',
    text: '결정 3건을 출처와 함께 요약했고, 담당 부서별 공유 초안을 작성했습니다. 검토 후 전송할까요?',
    chips: ['plan-act-observe', '멀티툴 오케스트레이션', '출처 인용'],
  },
];

export default function AgentChatDemo() {
  return (
    <ChatDemo
      title="Agent Trace"
      variant="trace"
      script={SCRIPT}
      caption="계획·도구호출·관찰을 반복하며 MCP·RAG·GraphRAG 도구를 연계"
    />
  );
}
